import ViewModel from './viewModel';
import qrCode from '../libraries/qrcode';
import StoreModel from '../models/storeModel';
import ProfileModel from '../models/profileModel';
import Config from '../configs/config';
import { parse } from 'query-string';

class ProfileViewModel extends ViewModel {
    constructor(StoreModel, ProfileModel) {
        super();
        this.viewStates = {
            // personalInfoDefault : true,  //DEPRECATED
            personalInfoEdit: false,
            personalInfoUpdatePW: false,
            // demographicInfoUpdate : false, //DEPRECATED
            demographicInSchool: false,
            storeActive: false,
            employeeInfoDefault: true,
            employeeInfoEdit: false,
            profileShowErrors: false,
            editDemographics: false,
            removeProfileStoresConfirm: false,
            showErrors: false,
            formFocus: false,
            focusValue: window.location.search.includes('passwordUpdated=true') ? 'password' : false,
            showQrCode: false,
            callSubscriptions: true,
            passwordUpdateSuccess: window.location.search.includes('passwordUpdated=true') ? true : false,
            showEmployeeSignup: parse(window.location.search)['employee'] ? true : false
        };
        this.events = {
            editProfileBasics: {
                type: 'click',
                element: '.js-account-personal-info-edit',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['personalInfoEdit', 'formFocus', 'focusValue', 'passwordUpdateSuccess'],
                        values: [true, true, 'basics', false]
                    },
                    events: {
                        names: ['submitProfileBasicsEditOnSubmit', 'cancelProfileBasicsEdit', 'editProfileBasics'],
                        values: [true, true, 'toggle']
                    },
                    extraFunctions: ['resetServerErrors'],
                    modelUpdate: []
                }
            },
            editProfileDemographics: {
                type: 'click',
                element: '.js-account-edit-profile-demographics',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['editDemographics', 'formFocus', 'focusValue'],
                        values: [true, true, 'demographics']
                    },
                    events: {
                        names: ['editProfileDemographics'],
                        values: ['toggle']
                    },
                    extraFunctions: ['resetServerErrors'],
                    modelUpdate: []
                }
            },
            updateProfilePassword: {
                type: 'click',
                element: '.js-account-personal-info-edit-password',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['personalInfoUpdatePW', 'formFocus', 'focusValue', 'passwordUpdateSuccess'],
                        values: [true, true, 'password', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['resetServerErrors'],
                    modelUpdate: []
                }
            },
            cancelProfileEdit: {
                type: 'click',
                element: '.js-account-cancel-personal-info-edit',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['personalInfoEdit', 'formFocus', 'profileShowErrors', 'showErrors', 'passwordUpdateSuccess'],
                        values: ['toggle', false, false, false, false]
                    },
                    events: {
                        names: ['cancelProfileBasicsEdit', 'editProfileBasics'],
                        values: [true, true]
                    },
                    extraFunctions: ['restoreEmail'],
                    modelUpdate: []
                }
            },
            cancelPasswordEdit: {
                type: 'click',
                element: '.js-account-cancel-password-edit',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['personalInfoUpdatePW', 'formFocus', 'profileShowErrors', 'showErrors', 'passwordUpdateSuccess'],
                        values: [false, false, false, false, false]
                    },
                    events: {
                        names: ['updateProfilePassword'],
                        values: [true]
                    },
                    extraFunctions: ['restoreEmail'],
                    modelUpdate: []
                }
            },
            cancelProfileBasicsEdit: {
                type: 'click',
                element: '.js-account-cancel-info-edit',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['personalInfoEdit', 'personalInfoUpdatePW', 'formFocus', 'profileShowErrors', 'showErrors', 'passwordUpdateSuccess'],
                        values: ['toggle', false, false, false, false, false]
                    },
                    events: {
                        names: ['cancelProfileBasicsEdit', 'editProfileBasics'],
                        values: ['toggle', true]
                    },
                    extraFunctions: ['restoreEmail'],
                    modelUpdate: []
                }
            },
            newUpdatePassword: {
                type: 'submit click',
                element: '.js-account-submit-password',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['personalInfoUpdatePW', 'formFocus', 'focusValue'],
                        values: [false, false, 'password']
                    },
                    events: {
                        names: [/* 'updateProfilePassword'*/],
                        values: []
                    },
                    extraFunctions: ['errorValidation'/* , 'coremetricsProfileRegistrationTag'*/],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'updatePassword',
                        modelProperty: 'password',
                        serviceMethod: 'updatePassword',
                        altModel: '' // PasswordModel
                    }, {
                        status: true,
                        modelMethod: 'authWithNewPassword',
                        modelProperty: '',
                        serviceMethod: 'authWithNewPassword',
                        altModel: ''
                    }]
                }
            },
            submitProfileBasicsEditOnSubmit: {
                type: 'submit click',
                element: '.js-account-submit-info-edit',
                status: false,
                rendered: false,
                sequentialModelUpdate: true,
                action: {
                    viewStates: {
                        names: ['personalInfoEdit', 'formFocus', 'focusValue', 'passwordUpdateSuccess'],
                        values: [false, false, 'basics', false]
                    },
                    events: {
                        names: ['submitProfileBasicsEditOnSubmit', 'cancelProfileBasicsEdit', 'editProfileBasics'],
                        values: []
                    },
                    extraFunctions: ['errorValidation', 'resetServerErrors'/* , 'coremetricsProfileRegistrationTag'*/],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'updateEmailForCheetah',
                        modelProperty: '',
                        serviceMethod: 'updateEmail',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'updateFirstLastName',
                        modelProperty: 'profile',
                        serviceMethod: 'patchFirstLastName',
                        altModel: ''
                    }]
                }
            },
            updateProfileDemographicsInSchoolYes: {
                type: 'change',
                element: '.js-account-demographic-inschool-yes-checked',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['demographicInSchool', 'passwordUpdateSuccess'],
                        values: [true, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },
            updateProfileDemographicsInSchoolNo: {
                type: 'change',
                element: '.js-account-demographic-inschool-no-checked',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['demographicInSchool', 'passwordUpdateSuccess'],
                        values: [false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'updateSchoolStatus',
                        modelProperty: '',
                        serviceMethod: '',
                        altModel: '',
                    }]
                }
            },
            changeProfileDemographics: {
                type: 'change',
                element: '.js-account-profile-demographics-form select, .js-account-profile-demographics-form input',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['editDemographics', 'formFocus', 'focusValue', 'passwordUpdateSuccess'],
                        values: [true, true, 'demographics', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['resetServerErrors'],
                    modelUpdate: []
                }
            },
            submitProfileDemographics: {
                type: 'submit click',
                element: '.js-account-demographic-edit-save',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['editDemographics', 'formFocus', 'passwordUpdateSuccess'],
                        values: [false, false, false]
                    },
                    events: {
                        names: ['editProfileDemographics'],
                        values: ['toggle']
                    },
                    extraFunctions: ['errorValidation'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'getDataFromSelectorParent',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: '',
                    }]
                }
            },
            cancelProfileDemographicsEdit: {
                type: 'click keydown',
                element: '.js-account-demographic-edit-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['editDemographics', 'formFocus', 'profileShowErrors', 'demographicInSchool', 'passwordUpdateSuccess'],
                        values: [false, false, false, false, false]
                    },
                    events: {
                        names: ['editProfileDemographics'],
                        values: ['toggle']
                    },
                    extraFunctions: ['resetDemographics'],
                    modelUpdate: []
                }
            },
            searchProfileStores: {
                type: 'submit click',
                element: '.js-account-search-profile-store',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['storeActive', 'formFocus', 'focusValue', 'passwordUpdateSuccess'],
                        values: [true, true, 'stores', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['errorValidation', 'resetServerErrors'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'fetchStores',
                        modelProperty: 'stores',
                        serviceMethod: 'getAddress',
                        altModel: StoreModel
                    }, {
                        status: true,
                        modelMethod: 'showEditableStoreSearch',
                        modelProperty: 'editableStoreSearch',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            submitProfileStores: {
                type: 'click',
                element: '.js-account-submit-profile-store',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['storeActive', 'formFocus', 'passwordUpdateSuccess'],
                        values: ['toggle', 'toggle', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['clearStoreInput'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'submitStores',
                        modelProperty: 'stores',
                        serviceMethod: 'updatePreferencesGlobal',
                        altModel: StoreModel
                    }]
                }
            },
            cancelProfileStoresSearch: {
                type: 'click',
                element: '.js-account-store-search-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['storeActive', 'formFocus', 'passwordUpdateSuccess'],
                        values: [false, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['clearStoreInput'],
                    modelUpdate: []
                }
            },
            removeProfileStoresModal: {
                type: 'touchstart click',
                element: '.js-account-remove-store-modal-trigger',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['removeProfileStoresConfirm', 'passwordUpdateSuccess'],
                        values: ['toggle', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'showEditableStoreDelete',
                        modelProperty: 'editableStoreDelete',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            removeProfileStoresModalCancel: {
                type: 'touchstart click',
                element: '.js-account-remove-favorite-store-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['removeProfileStoresConfirm', 'passwordUpdateSuccess'],
                        values: ['toggle', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },
            removeProfileStores: {
                type: 'touchstart click',
                element: '.js-account-remove-favorite-store',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['removeProfileStoresConfirm', 'passwordUpdateSuccess'],
                        values: ['toggle', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'removeStore',
                        modelProperty: 'stores',
                        serviceMethod: 'updatePreferencesGlobal',
                        altModel: StoreModel
                    }]
                }
            },

            createProfileUrbanOn: {
                type: 'click',
                element: '.js-account-urban-on-toggle',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['passwordUpdateSuccess'],
                        values: [false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'createUrbanOn',
                        modelProperty: 'subscriptions',
                        serviceMethod: 'createLoyaltySubscription',
                        altModel: ''
                    }]
                }
            },
            editProfileEmployeeStatus: {
                type: 'click',
                element: '.js-account-employee-toggle',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['employeeInfoDefault', 'employeeInfoEdit', 'formFocus', 'focusValue', 'passwordUpdateSuccess'],
                        values: [false, true, true, 'employee', false]
                    },
                    events: {
                        names: ['updateProfileEmployeeStatus'],
                        values: []
                    },
                    extraFunctions: ['resetServerErrors'],
                    modelUpdate: []
                }
            },

            editProfileEmployeeStatus: {
                type: 'click focus',
                element: '.js-account-employee-id-number',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'passwordUpdateSuccess'],
                        values: ['employee', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },

            updateProfileEmployeeStatus: {
                type: 'submit click',
                element: '.js-account-employee-input-submit',
                status: true,
                rendered: false,
                sequentialModelUpdate: true,
                action: {
                    viewStates: {
                        names: ['employeeInfoDefault', 'employeeInfoEdit', 'formFocus', 'passwordUpdateSuccess'],
                        values: [true, false, false, 'employee', false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['errorValidation', 'resetServerErrors'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'saveEmployee',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'checkEmployeeId',
                        modelProperty: 'profile',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            updateProfileEmployeeStatusOnSubmit: {
                type: 'submit',
                element: '.js-employee-form',
                status: true,
                rendered: false,
                sequentialModelUpdate: true,
                action: {
                    viewStates: {
                        names: ['employeeInfoDefault', 'employeeInfoEdit', 'formFocus', 'passwordUpdateSuccess'],
                        values: [true, false, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['errorValidation'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'saveEmployee',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'checkEmployeeId',
                        modelProperty: 'profile',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            cancelProfileEmployeeStatus: {
                type: 'click',
                element: '.js-account-employee-input-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['employeeInfoDefault', 'employeeInfoEdit', 'showErrors', 'formFocus', 'profileShowErrors', 'passwordUpdateSuccess'],
                        values: [true, false, false, false, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'deleteBarcode',
                        modelProperty: 'profile',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            routeToNavLink: {
                type: 'click',
                element: '.js-account-nav li a[data-link-name="address"], .js-account-navigation a[data-link-name="dashboard"]',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['passwordUpdateSuccess'],
                        values: [false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['routeToLink'],
                    modelUpdate: []
                }
            }

        };
    }
    errorHandling() {
        // do a bunch of error checks
    }

    logError() {
        // console.log('function ran');
    }

    run(functionName) {
        this[functionName]();
    }

    setEventAsRendered(event, evt) {
        event.rendered = !event.rendered;
        this.events[evt] = event;
    }

    /**
     * Change the url hash to the selector's data-link-name attribute value, and then change the route. Necessary for internal links within the app
     * @param {string} selector - DOM element
     * @returns {promise}
     */
    routeToLink(selector, model, session, store) {
        return super.updatePushState(selector, store);
    }

    errorValidation(selector, model) {
        return new Promise((resolve, reject) => {
            const form = jQuery(selector).closest('form');
            if (jQuery(form)[0].checkValidity() === false) {
                jQuery(form).find(":invalid").each(function(index, node) {
                    console.log(node.validationMessage);
                });
                Promise.resolve(super.updateViewState('profileShowErrors', true))
                    .then(viewModel => {
                        return model.attachErrorLocation(selector);
                    })
                    .then(vs => {
                        return reject({
                            type: 'validationError',
                            status: '',
                            data: {}
                        });
                    })
                    .catch(error => {
                        return reject({
                            type: 'validationError',
                            status: '',
                            data: {}
                        });
                    });
            } else {
                if(this.viewStates.personalInfoUpdatePW) {
                    selector = jQuery(selector).closest('form');
                    ProfileModel.saveTemps(ProfileModel, selector, 'password')
                        .then(model => {
                            super.updateViewState('showErrors', false);
                            this.viewStates.passwordUpdateSuccess = true;
                            return resolve(selector);
                        })
                        .catch(error => {
                            super.updateViewState('profileShowErrors', true);
                            this.viewStates.passwordUpdateSuccess = false;
                            return reject({
                                type: 'validationError',
                                status: '',
                                data: {}
                            });
                        });
                } else {
                    resolve(selector);
                }
            }
        });
    }

    /**
     * Create and display a unique QR code based on employee id
     * @param {Object} DOM - DOM
     * @param {string} id - id for DOM element,'qr-code'
     * @param {Object} model - ProfileModel
     */
    generateQrCode(DOM, id, model) {
        return new Promise((resolve, reject) => {
            let val;
            if (!model.initialized.subscriptions.postNeeded) {
                val = _.get(model, 'subscriptions.loyalty.loyaltyId');
            }
            if (typeof val !== 'undefined'
                && val !== undefined
                && val !== ''
                && !this.viewStates.showQrCode
                && document.getElementById(id)) {
                const elem = document.getElementById(id);
                const code = new qrCode(elem, val);
                super.updateViewState('showQrCode', true);
                resolve(code);
            } else {
                resolve(DOM);
            }

        });
    }

    /**
     * Fire a CoreMetrics Registration Tag by calling the builtin CM function
     * cmCreateRegistrationTag with email gathered from the address form
     */
    coremetricsProfileRegistrationTag() {
        const emailAddr = jQuery("input[data-cm-element='email-address']").val();

        if (typeof utag !== 'undefined') {
            Promise.resolve(cmCreateRegistrationTag(null, emailAddr));
        } else {
            Promise.resolve(true);
        }
    }

    restoreEmail() {
        const email = ProfileModel.profile.emailAddress;
        $(".js-account-basics-form-item[type='email']").val(email);
    }

    /**
     * On cancel of demographics edit, reset values to no
     * if yes was selected
     */
    resetDemographics() {
        const yesRadio = $('.js-account-demographic-inschool-yes-checked');
        const noRadio = $('.js-account-demographic-inschool-no-checked');
        const yesIsChecked = yesRadio.is(':checked');

        if (yesIsChecked) {
            yesRadio.prop('checked', false);
            noRadio.prop('checked', true);
        }
    }

    /**
     * On submit or cancel of store search,
     * reset search input
     */
    clearStoreInput() {
        $('.js-account-search-profile-store-input').val('');
    }

    /**
     * Paste a new virtual dom object instead of a diff/patch
     */
    fullReset() {
        Config.defaults.fullReset = true;
        Promise.resolve(this);
    }

    /**
     * Resets the AddressModel.errors object to clear out server side errors
     * @param {object} selector Element that triggered the event
     * @param {object} model    The current model
     * @param {string} session    The current user's authed session
     * @param {object} store    The current state of the redux store
     */
    resetServerErrors(selector, model, session, store) {
        model.errors = {};
        this.viewStates.showErrors = false;
    }

}
const ProfileView = new ProfileViewModel(StoreModel, ProfileModel);

export default ProfileView;
